import { useCallback, useEffect, useState } from "react";

export function useHoverExpand(collapsed) {
    const [hoverExpanded, setHoverExpanded] = useState(false);

    useEffect(() => {
        if (!collapsed) {
            setHoverExpanded(false);
        }
    }, [collapsed]);

    const onMouseEnter = useCallback(() => {
        if (collapsed) {
            setHoverExpanded(true);
        }
    }, [collapsed]);

    const onMouseLeave = useCallback(() => {
        setHoverExpanded(false);
    }, []);

    return {
        hoverExpanded,
        onMouseEnter,
        onMouseLeave,
    };
}
